import UCC1 from './Ucc1';

export default UCC1;
